import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import Landing from "@/pages/Landing";
import Survey from "@/pages/Survey";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancelled from "@/pages/CheckoutCancelled";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import AboutFrank from "@/pages/AboutFrank";

function App() {
  return (
    <div className="App font-body text-brand-ink">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<AboutFrank />} />
            <Route path="/survey" element={<Survey />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancelled" element={<CheckoutCancelled />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<Legal />} />
            <Route path="/terms" element={<Legal />} />
            <Route path="/refund" element={<Legal />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
